/**
 * MORNING2 (Task 9) - the Morning page's chat, as Layout needs to know of it. Provided by the Morning page AROUND its
 * `<Layout>` (a page renders Layout, so a provider inside Layout would sit below the page - see AiRail.integration.test).
 *
 * `focusChat` set = the page holds the assistant chat itself (Joseph switched on, or the page still finding out). Then,
 * on `/morning`, Layout renders NO `AiRail` - even when the rail's remembered open state is true; that state is kept for
 * the next page - and the top bar's Assistant button scrolls to and focuses the page's chat box: one chat, one list on
 * the screen. Absent (Robert, Joseph not switched on, every other page): the rail is the rail.
 */
import { createContext, useContext } from 'react';

export interface MorningChat {
  /** Scroll to and focus the Morning page's chat box. */
  focusChat?: () => void;
}

export const MorningChatContext = createContext<MorningChat>({});

export const useMorningChat = (): MorningChat => useContext(MorningChatContext);
